
import { Component, OnInit, Output, EventEmitter, Input, ViewChild, HostListener } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { configs } from '../configs/app.config';
import { GlobalService } from "../services/global.service";
import { HttpService } from '../services/http.service';
import { Subscription, Subject } from 'rxjs';
import { NgScrollbar } from 'ngx-scrollbar';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-benchmarking',
  templateUrl: './benchmarking.component.html',
  styleUrls: ['./benchmarking.component.scss']
})
export class BenchmarkingComponent {
  // @HostListener('click', ['$event']) onClick(event: any) {
  //   if (event.target.classList.contains('popup-bg')) {
  //     this.globalService.showTrue = true;
  //     this.globalService.showPopUp = "";
  //     document.body ? document.body.classList.remove('no-scroll') : '';
  //   }
  //   //  if (!event.target.classList.contains('sidebar-wrapper')) {
  //   //  this.globalService.sideTrue = false;
  //   // }
  //   //  if (event.target.classList.contains('sidebar-button')) {
  //   //  this.globalService.sideTrue = !this.globalService.sideTrue;
  //   // }
  // }

  title = 'Mozark';
  public isCurrentTab: any;
  public containers: Array<any> = new Array(0);
  public cardData: Array<any> = [];
  public getAllCard: any;
  public cardType: Object = configs['cardType'];
  public isShowCard: Boolean = true;
  public barLength: Array<any> = [];
  public barLengths: Array<any> = [];
  public timeLength: Array<any> = [];
  public hidethis: any;
  public hidethis1: any;
  public hidethis2: any;
  public currentPopUp: number;
  public app_bargraph: boolean = false;
  public app_bargraphs: boolean = false;
  public app_timeseries: boolean = false;
  public responseTimeseries: boolean = false;
  public responseHistogram: boolean = false;
  public responseBarGraph: boolean = false;
  public responseGraph: boolean = false;
  public count: any = 0;
  public matchInd: any = 0;
  public scoreName: any;
  public _scrollLeft: number = 0;
  public _scrollRight: number = 0;
  private scrollSubscription = Subscription.EMPTY;
  public errorMessage: string = "";
  public totalPageWidth: number = 0;
  public openPageAllow: boolean = false;
  public showSIdeButtonsPage: boolean = true;
  public pageMessage: string = '';
  public showPageName: Array<any> = [];
  public scrolledDown: boolean;
  pageRenameUpdate = new Subject<string>();
  public unitsgraph:any = {};
  @Input() guageValue: any;
  @Output() getGraph = new EventEmitter();
  @ViewChild('typeScroll', { static: false }) scrollbarRef: NgScrollbar;
  private headerSearchSubscription: Subscription;
  private updateCardSubscription: Subscription;
  private updateGraphSubscription: Subscription;

  ngOnDestroy() {
    this.headerSearchSubscription.unsubscribe();
    this.scrollSubscription.unsubscribe();
    this.updateCardSubscription.unsubscribe();
    this.updateGraphSubscription.unsubscribe();

  }

  constructor(private ngxService: NgxUiLoaderService, public globalService: GlobalService, private httpService: HttpService) {
    this.containers.push(this.containers.length);
    
    this.isCurrentTab = this.containers.length - 1;
    this.pageRenameUpdate.pipe(
      debounceTime(2000),
      distinctUntilChanged())
      .subscribe((value )=> {
        this.graphName[this.isCurrentTab] = (value);

        this.httpService.createPutRequest(configs['api']['benchmarkingpageTab'], {
            "pageTab":this.isCurrentTab,
            "pageName":value
        },this.globalService.order_id)
          .subscribe((response:any) => {
            if (response) {
              return;
            }
          });      
      });
    this.headerSearchSubscription = globalService.headerSearchMethod$.subscribe(
      ((params) => {
        // console.log('params', params);
        this.forPopupOpen(params, '', '');
      }));
    this.updateCardSubscription = globalService.updateCardSourceMethod$.subscribe(
      ((params) => {
        if (params && params['type'] === "benchmarking") {
          this.valueChangeEvent(params['data']);
        }
      }));
      this.updateGraphSubscription = globalService.updateGraphSourceMethod$.subscribe(
        ((params) => {
          if (params && params['type'] === "benchmarking") {
            this.valueChangeEvents(params);
          }
        }));

    if (this.globalService && this.globalService.order_id) {
      this.getOderById();
    }
    else {
      let inter = setInterval(() => {
        if (this.globalService && this.globalService.order_id) {
          clearInterval(inter);
          this.getOderById();
        }
      }, 100);
    }
  }
  public graphName=[];
  public comparexvaluesequence:Array<any> = [];
  public unitscards = [];
  public getOderById() {

    this.fetchCardList();
    this.ngxService.start();
    let pageArray = [];
    this.httpService.createGetRequest(configs['api']['fetchBenchMarkGraph']+this.globalService.order_id )
      .subscribe((res) => {
        this.graphName = [];

        if(res && res['units']){
          this.unitsgraph = res['units'][0];
          }
        this.comparexvaluesequence = res.xAxisValues;
        this.ngxService.stop();
        var check = [];
        var count = 0;
        let pageDataIndexChangeArray = [];
        for (var i = 0; i < res.list.length; i++) {
          let obj = res.list[i];
          if (check.indexOf(res.list[i]._id) == -1) {
            this.graphName.push(res.list[i].pageName);

            res.list[i]['graphNo'] = count;
            var obj1 = {
              'widgetId': res.list[i]._id,
              'pageTab': res.list[i]['graphNo']
            };
            pageDataIndexChangeArray.push(obj1);
            count++
            for (var j = i + 1; j < res.list.length; j++) {
              if (res.list[i].pageTab == res.list[j].pageTab) {
                check.push(res.list[j]._id);
                res.list[j]['graphNo'] = res.list[i]['graphNo'];
                var obj2 = {
                  'widgetId': res.list[j]._id,
                  'pageTab': res.list[i]['graphNo']
                };
                pageDataIndexChangeArray.push(obj2);
                break;
              }

            }
          }
        }
        let obj = {'list':pageDataIndexChangeArray};
        this.httpService.createPutRequest(configs['api']['updateBenchmarkGraphTab'], obj, this.globalService.order_id).subscribe((response: any) => {
                },
                  (error) => {
                  });
        this.responseGraph = true;
        if (res.maxPageTab > 0) {
          this.containers = [];
          for (let i = 0; i < res.maxPageTab; i++) {
            this.containers.push(i);
            //this.pageArray(res.list);     
            this.createDataArray(true, res.list);
          }
        }
      },
        (error) => {
          this.responseGraph = true;
          this.createDataArray(true, []);
          this.ngxService.stop();
          this.errorMessage = error && error['statusMessage'] ? error['statusMessage'] : error && error['error'] && error.error['statusMessage'] ? error.error['statusMessage'] : '';
        });
   
  }

  public pageDataArray: Array<any> = [];

  public createDataArray(bool, inputArray): void {
    this.pageDataArray = [];
    for (let index = 0; index < this.containers.length; index++) {
      const element = this.containers[index];
      this.pageDataArray.push({ pageNo: element, graphs: [],pageName:[] });
    }

    for (let index = 0; index < this.pageDataArray.length; index++) {

      for (let arrayIndex = 0; arrayIndex < inputArray.length; arrayIndex++) {
        const element = inputArray[arrayIndex];

        if (element['graphNo'] == this.pageDataArray[index]['pageNo']) {
          this.pageDataArray[index]['graphs'].push({ data: element, type: element.typeOfgraph, graphNo: this.pageDataArray[index]['pageNo'] });
          this.pageDataArray[index]['pageName'][0]=element.pageName?element.pageName:'Page'+index;
        }
      }
    }
    this.globalService.upDatedpageBenchDateArray = this.pageDataArray;

    if (this.responseGraph && this.pageDataArray.length == 0)
      this.pageDataArray.push({ pageNo: 0, graphs: [] });


    let tabs = document.getElementsByClassName('page-head-data');
    if (tabs && tabs[0]) {
      this.totalPageWidth = tabs[0].getBoundingClientRect()['width'];
    }

    this.showSIdeButtonsPage = this.pageDataArray.length > (Math.floor((this.totalPageWidth - 140) / 200));
    if (this.showSIdeButtonsPage) {
      let el = document.getElementById('outerDiv');
      el ? el.classList.add('show-status') : '';
    }
  }



  public addNewPage() {
    this.clickToScroll('next');
    if (this.pageDataArray[this.containers.length - 1]['graphs'].length > 0) {
      this.openPageAllow = false;
      this.containers.push(this.containers.length);
      this.isCurrentTab = this.containers.length - 1;
      this.pageDataArray.push({ pageNo: this.isCurrentTab, graphs: [] });
      let tabs = document.getElementsByClassName('page-head-data');
      if (tabs && tabs[0]) {
        this.totalPageWidth = tabs[0].getBoundingClientRect()['width'];
      }

      this.showSIdeButtonsPage = this.pageDataArray.length > (Math.floor((this.totalPageWidth - 140) / 200));

      if (this.showSIdeButtonsPage) {
        let el = document.getElementById('outerDiv');
        el ? el.classList.add('show-status') : '';
      }
    } else {
      this.pageMessage = "*Add alteast one graph on this page to add another page..";
      this.openPageAllow = true;
      setTimeout(() => {
        this.pageMessage = " ";
      }, 2000);
    }
  }

  public close(i) {
    if (this.containers && this.containers.length > 0) {
      if (i != 0) {
        this.isCurrentTab = i - 1;
        this.containers.splice(i, 1);
      }
      this.deleterealtedGraphs(i);
    }
  }

  public deleterealtedGraphs(i: number): void {
    let str = '';
    let id: number = 0;
    if (this.pageDataArray[i]['graphs'].length > 0) {
      for (let index = 0; index < this.pageDataArray[i]['graphs'].length; index++) {
        const element = this.pageDataArray[i]['graphs'][index];
        if (element['type'] == "Compare") {
          str = 'deletecompare';
          id = element['data']['_id'];
        } else if (element['type'] == "Histogram") {
          str = 'deletehistogram';
          id = element['data']['_id'];


        } else if (element['type'] == "TimeSeries") {
          str = 'deletetimeseries';
          id = element['data']['_id'];


        }
        //this.ngxService.start();
        let ele: any = document.getElementsByClassName('popup-bg')[0];
        this.httpService.createDeleteRequest(configs['api']['GraphBenchmark'], str, id, this.globalService.order_id)
          .subscribe((res) => {
            this.ngxService.stop();
            this.valueChangeEvents('');
            if(ele)
            ele.scrollTop = 20;
            document.body ? document.body.classList.remove('no-scroll') : '';
          },
            (error) => {
              if(ele)
              ele.scrollTop = 20;
              this.errorMessage = error && error['statusMessage'] ? error['statusMessage'] : error && error['error'] && error.error['statusMessage'] ? error.error['statusMessage'] : '';

              // this.warningMessage = (error.error['statusCode'] && error.error['statusCode']===406)?error.error['statusMessage']:'';
              setTimeout(() => {
                this.errorMessage = "";
                //  this.warningMessage="";
              }, 6000);

            })
      }
    } else {

      this.pageDataArray.splice(i, 1);
      for (let index = i; index < this.pageDataArray.length; index++) {
        const element = this.pageDataArray[index];
        element['pageNo'] = element['pageNo'] - 1;
      }
    }

  }

  public fetchCardList() {
    this.ngxService.start();
    this.httpService.createGetRequest(configs['api']['fetchCard']+this.globalService.order_id + '?cardType=benchmarking')
      .subscribe((res) => {
        this.unitscards = res['units'][0];
        this.ngxService.stop();
        for (let i = 0; i < res.list.length; i++) {
          this.cardData.push(res.list[i]);
        }
      },
        (error) => {
          this.ngxService.stop();
          this.errorMessage = error && error['statusMessage'] ? error['statusMessage'] : error && error['error'] && error.error['statusMessage'] ? error.error['statusMessage'] : '';

        })
  }

  public showCurrenttab(i) {
    this.isCurrentTab = i;
  }


  ngAfterViewInit() {
    this.scrollSubscription = this.scrollbarRef.scrolled.subscribe(res => {
      var st = res.target.scrollLeft;
      if (st > this._scrollLeft) {
        //move right
        this.scrolledDown = true;
      } else {
        //move left
        this.scrolledDown = false;
      }

      this._scrollLeft = st <= 0 ? 0 : st; // For Mobile or negative scrolling      }
    })
    // this.tabbingShowName();
  }
  
  public tabbingShowName() {
    for (let i = 0; i < 4; i++) {
      if (localStorage.getItem('pageTabname') && localStorage.getItem('pageTabname').length > 0) {
        this.showPageName.push(JSON.parse(localStorage.getItem('pageTabname')));
      }
    }
  }

  public forPopupOpen(key, str, ind) {
    if (key == 'viewMore') {
      this.globalService.showTrue = false;
    }
    if (str == "app-bargraph") {
      this.app_bargraph = true;
      this.matchInd = ind;
    } else if (str == "app-timeseries") {
      this.app_timeseries = true;
      this.matchInd = ind;
    } else {
      this.app_bargraphs = true;
      this.matchInd = ind;
    }
    this.globalService.showPopUp = key;
    // console.log(this.globalService.showPopUp);
    document.body ? document.body.classList.add('no-scroll') : '';
  }

  public valueChangeEvent($event) {
    this.cardData = [];
    this.ngxService.start();
    this.httpService.createGetRequest(configs['api']['fetchCard']+this.globalService.order_id + '?cardType=benchmarking')
      .subscribe((res) => {
        this.unitscards = res['units'][0];;
        this.ngxService.stop();
        for (let i = 0; i < res.list.length; i++) {
          this.cardData.push(res.list[i]);
        }
      },
        (error) => {
          this.ngxService.stop();
          this.errorMessage = error && error['statusMessage'] ? error['statusMessage'] : error && error['error'] && error.error['statusMessage'] ? error.error['statusMessage'] : '';
          //  setTimeout(() => {
          //  this.errorMessage = "";
          //}, 3000);
        })
  }

  public valueChangeEvents(obj) {
    if ((+obj.ind + 1) > this.containers.length) {
      this.containers.push(obj.ind);

    } else {
      this.containers = [];
      this.containers.push(this.containers.length);
      this.isCurrentTab = this.containers.length - 1;
    }

    this.isCurrentTab = obj.ind ? obj.ind : 0;
    let flag = false;
    if (obj.bool && this.pageDataArray[obj.ind] && this.pageDataArray[obj.ind]['graphs']['length'] === 1) {
      if (obj.ind != 0) {
        flag = true;
        this.containers.splice(obj.ind, 1);
      }
      if (flag) {
        this.isCurrentTab = obj.ind - 1;
      } else {
        this.containers = [];
        this.containers.push(this.containers.length);
        this.isCurrentTab = this.containers.length - 1;
        this.isCurrentTab = 0;
      }
    }
    this.pageDataArray = [];
    this.ngxService.start();
    let pageArray = [];
    this.httpService.createGetRequest(configs['api']['fetchBenchMarkGraph']+this.globalService.order_id)
      .subscribe((res) => {
        this.graphName=[];
        if(res && res['units']){
          this.unitsgraph = res['units'][0];
          }
        this.ngxService.stop();
        this.comparexvaluesequence = res.xAxisValues;
        var check = [];
        var count = 0;
        let pageDataIndexChangeArray = [];
        for (var i = 0; i < res.list.length; i++) {
          let obj = res.list[i];
          if (check.indexOf(res.list[i]._id) == -1) {
            this.graphName.push(res.list[i].pageName);
            res.list[i]['graphNo'] = count;
            var obj1 = {
              'widgetId': res.list[i]._id,
              'pageTab': res.list[i]['graphNo']
            };
            pageDataIndexChangeArray.push(obj1);
            count++
            for (var j = i + 1; j < res.list.length; j++) {
              if (res.list[i].pageTab == res.list[j].pageTab) {
                check.push(res.list[j]._id);
                res.list[j]['graphNo'] = res.list[i]['graphNo'];
                var obj2 = {
                  'widgetId': res.list[j]._id,
                  'pageTab': res.list[i]['graphNo']
                };
                pageDataIndexChangeArray.push(obj2);
                break;
              }

            }
          }
        }
        let obj = {'list':pageDataIndexChangeArray};
        this.httpService.createPutRequest(configs['api']['updateBenchmarkGraphTab'], obj, this.globalService.order_id).subscribe((response: any) => {
                },
                  (error) => {
                  });
        if (res.maxPageTab > 0) {
          this.containers = [];
          for (let i = 0; i < res.maxPageTab; i++) {
            this.containers.push(i);
            //this.pageArray(res.list);     
            this.createDataArray(true, res.list);
          }
        }
      },
        (error) => {
          this.responseGraph = true;
          this.createDataArray(true, []);
          this.ngxService.stop();
          this.errorMessage = error && error['statusMessage'] ? error['statusMessage'] : error && error['error'] && error.error['statusMessage'] ? error.error['statusMessage'] : '';
        });
   
  }

  public graphValueEvent(event) {
    this.barLength.push(event);
  }

  public clickToScroll(scrollType) {
    let offsetHeight = this._scrollLeft ? this._scrollLeft : 0;
    if (scrollType == 'prev') {
      this.scrollbarRef.scrollTo({ left: this._scrollLeft - 200 });

    } else {
      if (this.scrolledDown) {
        this.scrolledDown = false;
      }
      this.scrollbarRef.scrollTo({ left: offsetHeight + 220 });
    }
  }

}
